import { type ReactNode } from 'react'
import { Link } from 'react-router'
import { Logo } from './Logo'
import { UserMenu } from './UserMenu'
import { authClient } from '@/lib/auth-client'

export function AppHeader({ children }: { children?: ReactNode }) {
  const session = authClient.useSession()
  const user = session.data?.user
  return (
    <header className="sticky top-0 z-20 flex h-14 items-center gap-3 border-b border-line/70 bg-(--chrome) px-4 backdrop-blur-xl backdrop-saturate-150">
      <Link to="/" className="rounded-md outline-offset-4">
        <Logo />
      </Link>
      <div className="flex min-w-0 flex-1 items-center gap-2">{children}</div>
      {user && <UserMenu id={user.id} name={user.name} email={user.email} />}
    </header>
  )
}
